import React, { useEffect, useState } from "react";
import { Container, Col, Badge, Nav, Row, Carousel } from "react-bootstrap";
import "./../../assets/css/PackegDetails.css";
import TourePricingDetails from "./TourePricingDetails";
import TourIncludes from "./TourIncludes";
import TourBookingCard from "./TourBookingCard";
import ItinerarySection from "./ItinerarySection";
import TourDetails from "./TourDetails";
import TourInformation from "./TourInformation";
import CancellationPolicy from "./CancellationPolicy";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../../component/commanfile";
import { FaCompass, FaSuitcase, FaHotel, FaShieldAlt ,FaFilePdf} from "react-icons/fa";
import { jsPDF } from "jspdf";
import logoImg from './../../assets/Logo.png';


const PackegDetails = () => {
  const location = useLocation();
  const { id } = useParams();
  const data = id.startsWith("fit-") ? id.substring(4) : id;

  const [packages, setPackages] = useState([]);
  const [webSettings, setWebSettings] = useState(null);

  useEffect(() => {
    const fetchPackages = async (data) => {
      try {
        const response = await axios.get(id.startsWith("fit-") ? `${BASE_URL}api/fit/${data}` : `${BASE_URL}api/tour/${data}`);
        setPackages(response?.data);
      } catch (error) {
        console.error("Error fetching packages:", error);
      }
    };

    fetchPackages(data);
  }, [data]);

  useEffect(() => {
    const fetchWebSettings = async () => {
      try {
        const res = await axios.get(`${BASE_URL}api/web-settings`);
        setWebSettings(res.data);
      } catch (err) {
        console.error("Web settings error", err);
      }
    };

    fetchWebSettings();
  }, []);

  const generateFullTourPDF = async (packages, webSettings) => {
    try {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      const PRIMARY = [12, 45, 87];
      const ACCENT = [220, 53, 69];
      const BORDER = [220, 225, 230];
      const ensureSpace = (currentY, neededHeight = 20) => {
        if (currentY + neededHeight > pageHeight - 20) {
          doc.addPage();
          return 20; // new page start Y
        }
        return currentY;
      };

      const clean = (h) => h ? h.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").trim() : "";

      const getPoints = (html) => {
        if (!html) return [];
        return html.split(/<p>|<\/p>|<li>|<\/li>|<br>|•|✔|✖/)
          .map(item => clean(item))
          .filter(item => item.length > 5);
      };

      const getBase64 = async (url) => {
        try {
          const response = await fetch(url);
          const blob = await response.blob();
          return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          });
        } catch (err) {
          console.error("Image fetch error:", err, url);
          return null;
        }
      };

const getBase64Compressed = async (url, quality = 0.3) => {
  try {
    const response = await fetch(url, { mode: "cors" });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const blob = await response.blob();

    const imgURL = URL.createObjectURL(blob);

    const img = new Image();
    img.src = imgURL;

    await new Promise((res, rej) => {
      img.onload = res;
      img.onerror = rej;
    });

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const maxWidth = 800;
    const scale = Math.min(1, maxWidth / img.width);

    canvas.width = img.width * scale;
    canvas.height = img.height * scale;

    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    URL.revokeObjectURL(imgURL);

    return canvas.toDataURL("image/jpeg", quality);
  } catch (err) {
    console.error("Image compression error:", err);
    return null;
  }
};
      /* =============================================
         PAGE 1 – PROFESSIONAL COVER
      ============================================= */
      const headerHeight = 28;
      let y = 0;

      doc.setFillColor(255, 255, 255);
      doc.rect(0, 0, pageWidth, headerHeight, "F");

      // Logo
      const logoData = logoImg ? await getBase64(logoImg) : null;
      if (logoData) {
        const logoWidth = 40, logoHeight = 35;
        doc.addImage(logoData, "PNG", 10, -5, logoWidth, logoHeight);
      }

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.setTextColor(...PRIMARY);
      doc.text("Radheshyam Travels Pvt Ltd", 60, 15);

      // Accent line
      doc.setDrawColor(...ACCENT);
      doc.setLineWidth(0.8);
      doc.line(15, headerHeight - 2, pageWidth - 15, headerHeight - 2);


      /* --- BANNER IMAGE --- */
      y = headerHeight;

      if (packages.video) {
       const thumbnailUrl = packages.thumbnail
  ? `${BASE_URL}/api/image?file=${encodeURIComponent(packages.thumbnail)}`
  : "https://placehold.co/1200x800?text=No+Image";

  const thumbData = await getBase64Compressed(thumbnailUrl, 0.3);
  console.log("packages.thumbnail", thumbnailUrl, `${BASE_URL}/api/image?file=${encodeURIComponent(packages.thumbnail)}`,thumbData);

if (thumbData) {
  doc.addImage(thumbData, "JPEG", 0, y, pageWidth, 100);
} else {
  console.error("❌ Image failed in PDF:", thumbnailUrl);
}
      }

      y += 78;


      /* --- PACKAGE TITLE CARD --- */
      /* --- PACKAGE TITLE CARD (DYNAMIC HEIGHT) --- */
      const titleText = packages.name?.toUpperCase() || "TOUR PACKAGE";
      const maxWidth = pageWidth - 40; // Card ke andar ki margins

      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);

      // 1. Title ko wrap karein aur height calculate karein
      const splitTitle = doc.splitTextToSize(titleText, maxWidth);
      const titleLineHeight = 7;
      const titleTotalHeight = splitTitle.length * titleLineHeight;

      // 2. Card ki total height (Title + Duration line + Padding)
      const cardPadding = 15;
      const subInfoHeight = 10; // Duration aur Destination line ke liye
      const dynamicCardHeight = titleTotalHeight + subInfoHeight + cardPadding;

      // 3. Background box draw karein
      doc.setFillColor(245, 247, 250);
      doc.roundedRect(15, y, pageWidth - 30, dynamicCardHeight, 4, 4, "F");

      // 4. Title Text render karein
      doc.setTextColor(...PRIMARY);
      doc.text(splitTitle, 20, y + 12);

      // 5. Sub-info (Duration & Destination) ko Title ke niche set karein
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(80);

      const subInfoY = y + 12 + titleTotalHeight + 2; // Title ke end se thoda niche
      const durationText = `Duration: ${packages.itinerary.length || 0} Days / ${packages.itinerary.length - 1 || 0} Nights`;
      doc.text(durationText, 20, subInfoY);

      if (packages.destination) {
        doc.text(`Destination: ${packages.destination}`, 110, subInfoY);
      }

      // 6. Global 'y' coordinate update karein taaki Overview overlap na ho
      y += dynamicCardHeight + 10;


      /* --- OVERVIEW BOX (MAX 4 LINES) --- */
      const overviewText =
        clean(packages.overview || packages.description || packages.shortDescription || "");

      if (overviewText) {
        doc.setFillColor(255, 255, 255);
        doc.setDrawColor(...BORDER);
        doc.roundedRect(15, y, pageWidth - 30, 30, 3, 3, "FD");

        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.setTextColor(...PRIMARY);
        doc.text("OVERVIEW", 20, y + 8);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9.5);
        doc.setTextColor(60);

        const lines = doc.splitTextToSize(overviewText, pageWidth - 45);
        const limited = lines.slice(0, 4);

        doc.text(limited, 20, y + 14);

        y += 30;
      }


      const highlights = getPoints(packages.highlights);
      let highlightY = headerHeight + 155;
      doc.setFontSize(16); doc.setTextColor(...PRIMARY);
      doc.text("TOUR HIGHLIGHTS", 15, highlightY + 10);
      doc.setDrawColor(...ACCENT); doc.setLineWidth(0.8);
      doc.line(15, highlightY + 12, 60, highlightY + 12);

      highlightY += 20;
      doc.setFontSize(10); doc.setTextColor(60);
      highlights.slice(0, 8).forEach(h => {
        doc.setFillColor(...ACCENT); doc.circle(17, highlightY - 1, 0.8, "F");
        const txt = doc.splitTextToSize(h, pageWidth - 35);
        doc.text(txt, 22, highlightY);
        highlightY += (txt.length * 6);
      });

      /* --- MINI GALLERY (OPTIONAL) --- */



      doc.addPage();
      // /* =============================================
      //    TOUR HIGHLIGHTS
      // ============================================= */
      const prices = [
        ["Double Occupancy", packages.doubleOccupancy],
        ["Triple Occupancy", packages.tripleOccupancy],
        ["Single Occupancy", packages.singleOccupancy],
        ["Child Price", packages.childPrice]
      ].filter(([_, val]) => Number(val) > 0);



      /* =============================================
         PAGE 2 – PRICING
      ============================================= */

      let priceY = 20;

      let startX = 15;
      let startY = 20;
      const cardWidth = 40;      // width of each card
      const cardHeight = 20;     // height of each card
      const gapX = 5;           // horizontal gap between cards

      // Dynamic prices
      const pricing = [
        ["Double Occupancy", packages.doubleOccupancy],
        ["Triple Occupancy", packages.tripleOccupancy],
        ["Single Occupancy", packages.singleOccupancy],
        ["Child Price", packages.childPrice]
      ].filter(([_, val]) => Number(val) > 0);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.setTextColor(...PRIMARY);
      doc.text(`PACKAGE PRICING ${pricing.length > 0 ? "(Per Person)" : ""}`, startX, startY);

      // Calculate starting X so all cards are centered
      const totalWidth = pricing.length * cardWidth + (pricing.length - 1) * gapX;
      let currentX = startX; // default left-aligned
      if (totalWidth < pageWidth - 2 * startX) {
        currentX = startX + ((pageWidth - 2 * startX - totalWidth) / 2); // center the row
      }
      let currentY = ensureSpace(startY + 8, 30);
      if (pricing.length > 0) {

        pricing.forEach(([label, val]) => {
          // Card background
          doc.setFillColor(235, 238, 242); // light gray
          doc.roundedRect(currentX, currentY, cardWidth, cardHeight, 2, 2, "F");

          // Card title
          doc.setFont("helvetica", "bold");
          doc.setFontSize(11);
          doc.setTextColor(...PRIMARY);
          doc.text(label, currentX + 2, currentY + 8);

          // Card price
          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.setTextColor(0); // black
          doc.text(`Rs. ${Number(val).toLocaleString("en-IN")}/-`, currentX + 2, currentY + 15);

          // Move to next card in the same row
          currentX += cardWidth + gapX;
        });
      }

      priceY = pricing.length > 0 ? currentY + cardHeight + 10 : currentY; // update Y for next section (vehicles table)



      /* =============================================
         PAGE 2 – FIT VEHICLE TABLE
      ============================================= */
      if (packages.forfit?.length > 0) {
        const startX = 15;
        let currentY = priceY + 2;
        const ROW_HEIGHT = 10;
        const tableWidth = pageWidth - 30;
        const colWidths = [tableWidth * 0.45, tableWidth * 0.25, tableWidth * 0.30];
        const pageHeight = doc.internal.pageSize.height;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.setTextColor(...PRIMARY);
        doc.text("FIT VEHICLES", startX, currentY);
        currentY += 5;

        doc.setFillColor(...PRIMARY);
        doc.rect(startX, currentY, tableWidth, ROW_HEIGHT, "F");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);
        doc.setTextColor(255);
        doc.text("VEHICLE TYPE", startX + 2, currentY + 7);
        doc.text("CAPACITY", startX + colWidths[0] + 2, currentY + 7);
        doc.text("PRICE", startX + colWidths[0] + colWidths[1] + 2, currentY + 7);
        currentY += ROW_HEIGHT;

        let rowIndex = 0;

        packages.forfit.forEach(vehicle => {
          const vName = vehicle.vihicalname || "Standard Vehicle";

          vehicle.seatConfigurationRate.forEach((rate, i) => {

            // PAGE BREAK CONDITION
            if (currentY + ROW_HEIGHT > pageHeight - 15) {
              doc.addPage();
              currentY = 20;

              doc.setFillColor(...PRIMARY);
              doc.rect(startX, currentY, tableWidth, ROW_HEIGHT, "F");

              doc.setFont("helvetica", "bold");
              doc.setFontSize(11);
              doc.setTextColor(255);

              doc.text("VEHICLE TYPE", startX + 2, currentY + 7);
              doc.text("CAPACITY", startX + colWidths[0] + 2, currentY + 7);
              doc.text("PRICE", startX + colWidths[0] + colWidths[1] + 2, currentY + 7);

              currentY += ROW_HEIGHT;
            }

            if (rowIndex % 2 === 0) {
              doc.setFillColor(235, 238, 242);
              doc.rect(startX, currentY, tableWidth, ROW_HEIGHT, "F");
            }

            doc.setFont("helvetica", i === 0 ? "bold" : "italic");
            doc.setFontSize(10);
            doc.setTextColor(...PRIMARY);
            doc.text(i === 0 ? vName.toUpperCase() : "(Same Vehicle)", startX + 2, currentY + 7);

            doc.setFont("helvetica", "normal");
            doc.text(`${rate.numberOfPerson} Pax`, startX + colWidths[0] + 2, currentY + 7);

            doc.setFont("helvetica", "bold");
            doc.text(`Rs. ${Number(rate.price).toLocaleString('en-IN')}/-`, startX + colWidths[0] + colWidths[1] + 2, currentY + 7);

            currentY += ROW_HEIGHT;
            rowIndex++;
          });
        });
      }

      if (packages.type !== "fit") {

        doc.addPage();

        doc.setFontSize(16);
        doc.setTextColor(...PRIMARY);
        doc.text("AVAILABLE DEPARTURE SLOTS", 15, 25);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const dates = (packages.tourSchedule || [])
          .map(d => new Date(d.startDate))
          .filter(d => d >= today)
          .sort((a, b) => a - b);

        const grouped = {};

        dates.forEach(date => {
          const key = date.toLocaleString('default', { month: 'short' }).toUpperCase() + " " + date.getFullYear();
          if (!grouped[key]) grouped[key] = [];
          grouped[key].push(date.getDate());
        });

        const startX = 15;
        let startY = 35;
        const gap = 4;
        const col1Width = 35;
        const col2Width = pageWidth - startX - col1Width - 15;

        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);

        for (const [monthYear, days] of Object.entries(grouped)) {

          const datesText = days.map(d => String(d).padStart(2, "0")).join(", ");

          // WRAP TEXT
          const wrappedDates = doc.splitTextToSize(datesText, col2Width - 4);

          // AUTO HEIGHT
          const dynamicHeight = wrappedDates.length * 6 + 6;

          // PAGE BREAK
          if (startY + dynamicHeight > doc.internal.pageSize.height - 15) {
            doc.addPage();
            startY = 35;
          }

          doc.setDrawColor(...BORDER);

          doc.setFillColor(245, 245, 245);
          doc.rect(startX, startY, col1Width, dynamicHeight, "FD");

          doc.setFillColor(255, 255, 255);
          doc.rect(startX + col1Width, startY, col2Width, dynamicHeight, "FD");

          doc.setTextColor(...PRIMARY);
          doc.text(monthYear, startX + 2, startY + 7);

          doc.setTextColor(100);
          doc.text(wrappedDates, startX + col1Width + 2, startY + 7);

          startY += dynamicHeight + gap;
        }
      }




      /* =============================================
         PAGE 2 – DAY-WISE ITINERARY
      ============================================= */
      doc.addPage();
      let iY = 20;
      doc.setFontSize(16); doc.setTextColor(...PRIMARY); doc.text("DAY-WISE ITINERARY", 15, iY);

      packages.itinerary.forEach((item) => {
        const cardWidth = pageWidth - 30;
        const descLines = doc.splitTextToSize(clean(item.description), cardWidth - 10);
        const actList = item.activities || [];
        const activitiesHeight = actList.length > 0 ? (6 + (actList.length * 5)) : 0;
        const cardHeight = 25 + (descLines.length * 5) + activitiesHeight;

        if (iY + cardHeight > pageHeight - 30) { doc.addPage(); iY = 20; }

        doc.setFillColor(245, 247, 250);
        doc.roundedRect(15, iY + 5, cardWidth, cardHeight, 3, 3, "F");

        doc.setFont("helvetica", "bold"); doc.setFontSize(11); doc.setTextColor(...PRIMARY);
        doc.text(`DAY ${item.day}: ${item.title.toUpperCase()}`, 20, iY + 12);

        doc.setFont("helvetica", "normal"); doc.setFontSize(10); doc.setTextColor(60);
        doc.text(descLines, 20, iY + 20);

        let localY = iY + 20 + (descLines.length * 5);

        if (actList.length > 0) {
          doc.setFont("helvetica", "bold"); doc.setTextColor(...PRIMARY);
          doc.text("Activities Covered:", 20, localY + 2);
          doc.setFont("helvetica", "normal"); doc.setFontSize(9);
          actList.forEach(act => {
            localY += 5;
            doc.text(`• ${act}`, 25, localY + 2);
          });
          localY += 5;
        }

        doc.setFont("helvetica", "bold"); doc.setFontSize(9); doc.setTextColor(...ACCENT);
        doc.text(`Hotel: ${item.hotalName || 'Premium Stay'} | Meals: ${item.meals.join(", ")}`, 20, localY + 5);

        iY += cardHeight + 6;
      });

      /* =============================================
         PAGE 3 – AVAILABLE DEPARTURE DATES (IF NOT FIT)
      ============================================= */



      /* =============================================
         PAGE 4 – INCLUSIONS & EXCLUSIONS
      ============================================= */
      doc.addPage();
      doc.setFontSize(16); doc.setTextColor(...PRIMARY);
      doc.text("TOUR POLICIES", 15, 20);

      const drawPolicy = (title, data, color, yPos) => {
        doc.setFontSize(13); doc.setFont("helvetica", "bold"); doc.setTextColor(...color);
        doc.text(`--- ${title} ---`, 15, yPos);
        let localY = yPos + 10;
        doc.setFontSize(9.5); doc.setFont("helvetica", "normal"); doc.setTextColor(60);
        data.forEach(p => {
          if (localY > pageHeight - 20) return;
          doc.setFillColor(...color); doc.circle(17, localY - 1, 0.8, "F");
          const txt = doc.splitTextToSize(p, pageWidth - 35);
          doc.text(txt, 22, localY); localY += (txt.length * 6);
        });
        return localY;
      };

      let nextY = drawPolicy("INCLUSIONS", getPoints(packages.tourIncludes), [34, 139, 34], 35);
      drawPolicy("EXCLUSIONS", getPoints(packages.tourExcludes), [180, 40, 40], nextY + 10);

      const drawSectionTitle = (text, y) => {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.setTextColor(...PRIMARY);
        doc.text(text.toUpperCase(), 15, y);
        doc.setDrawColor(...ACCENT);
        doc.setLineWidth(0.8);
        doc.line(15, y + 2, 80, y + 2);
        return y + 12;
      };

      const drawParagraph = (text, y) => {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.setTextColor(60);
        const lines = doc.splitTextToSize(text, pageWidth - 30);
        doc.text(lines, 15, y);
        return y + lines.length * 6 + 6;
      };
      /* =============================================
         PAGE 5 – COMPANY INFORMATION (WEB SETTINGS)
      ============================================= */
      if (webSettings) {
        doc.addPage();
        let y = 25;

        // COMPANY INFO TITLE
        y = drawSectionTitle("Company Information", y);

        /* -------- OUR OFFICE CARD -------- */
        doc.setFillColor(245, 247, 250);
        doc.roundedRect(15, y, pageWidth - 30, 42, 3, 3, "F");

        const office = webSettings.ourOffice?.[0];

        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.setTextColor(...PRIMARY);
        doc.text("Our Office", 20, y + 7);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.setTextColor(60);

        let oy = y + 12;
        if (office) {
          doc.text(`• ${office.name}`, 20, oy); oy += 5;

          // Wrap address text to fit within page width (e.g., 160)
          const addressText = doc.splitTextToSize(`Address: ${office.address}`, pageWidth - 40);
          doc.text(addressText, 20, oy);
          oy += addressText.length * 5;

          const phoneText = doc.splitTextToSize(`Phone: ${office.phone}`, pageWidth - 40);
          doc.text(phoneText, 20, oy);
          oy += phoneText.length * 5;

          const emailText = doc.splitTextToSize(`Email: ${office.email}`, pageWidth - 40);
          doc.text(emailText, 20, oy);
          oy += emailText.length * 5;

          const websiteText = doc.splitTextToSize(`Website: ${office.websiteurl}`, pageWidth - 40);
          doc.text(websiteText, 20, oy);
          oy += websiteText.length * 5;
        }

        y += 55;

        /* -------- ABOUT -------- */
        y = drawSectionTitle("About Radheshyam Travels", y);
        y = drawParagraph(clean(webSettings.aboutRadheshyamTravels), y);

        /* -------- SERVICES -------- */
        y = drawSectionTitle("Services & Transportation", y);
        y = drawParagraph(clean(webSettings.servicesAndTransportation), y);

        /* -------- CANCELLATION POLICY -------- */
        /* -------- CANCELLATION POLICY (IMAGE STYLE – DYNAMIC) -------- */
        y = drawSectionTitle("Cancellation Policy", y);

        const policies = webSettings?.cancellationPolicy || [];
        if (!policies.length) return;

        // sort ascending
        policies.sort((a, b) => Number(a.prior_of_day) - Number(b.prior_of_day));

        const startX = 15;
        const tableWidth = pageWidth - 30;
        const rowHeight = 9;
        const labelColWidth = 45;
        const colWidth = (tableWidth - labelColWidth) / policies.length;

        /* ================= HEADER ROW ================= */
        doc.setFillColor(235, 238, 242);
        doc.rect(startX, y, tableWidth, rowHeight, "F");

        doc.setFont("helvetica", "bold");
        doc.setFontSize(9.5);
        doc.setTextColor(40);
        doc.text("No. of days prior", startX + 2, y + 6);

        // dynamic day ranges
        // Example: dynamically split and draw cell text in header row
        policies.forEach((p, i) => {
          const from = i == 0 ? 0 : policies[i - 1].prior_of_day + 1;
          const to = p.prior_of_day;

          const dayRangeText = `${p.prior_of_day}`;
          const wrappedText = doc.splitTextToSize(dayRangeText, colWidth); // -4 for padding

          // center align vertically and horizontally
          wrappedText.forEach((line, idx) => {
            doc.text(
              line,
              startX + labelColWidth + colWidth * i + colWidth / 2,
              y + 6 + idx * 5,
              { align: "center" }
            );
          });
        });

        /* ================= SECOND ROW ================= */
        y += rowHeight;

        doc.setFillColor(250, 251, 252);
        doc.rect(startX, y, tableWidth, rowHeight, "F");

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9.5);
        doc.setTextColor(60);
        doc.text("Cancellation fee", startX + 2, y + 6);

        // dynamic percentage
        policies.forEach((p, i) => {
          doc.setFont("helvetica", "bold");
          doc.text(
            `${p.refundable}`,
            startX + labelColWidth + colWidth * i + colWidth / 2,
            y + 6,
            { align: "center" }
          );
        });

        /* ================= BORDERS ================= */
        doc.setDrawColor(170);
        doc.setLineWidth(0.6);

        // outer border
        doc.rect(startX, y - rowHeight, tableWidth, rowHeight * 2);

        // vertical lines
        let lineX = startX + labelColWidth;
        for (let i = 0; i < policies.length; i++) {
          doc.line(lineX, y - rowHeight, lineX, y + rowHeight);
          lineX += colWidth;
        }

        // horizontal line
        doc.line(startX, y, startX + tableWidth, y);

        y += rowHeight + 12;



        /* -------- IMPORTANT REMARKS -------- */
        y = drawSectionTitle("Important Remarks", y);
        y = drawParagraph(clean(webSettings.web_tours_remarks), y);
      }


      /* =============================================
         FOOTER
      ============================================= */
      const total = doc.internal.getNumberOfPages();
      for (let i = 1; i <= total; i++) {
        doc.setPage(i);
        doc.setFillColor(...PRIMARY); doc.rect(0, pageHeight - 12, pageWidth, 12, "F");
        doc.setFontSize(8); doc.setTextColor(255);
        doc.text(`Radheshyam Group | Page ${i} of ${total}`, pageWidth / 2, pageHeight - 5, { align: "center" });
      }

      const pdfBlob = doc.output("blob");
      return pdfBlob;
    } catch (err) { console.error("PDF Gen Error:", err); }
  };


console.log("test",`${BASE_URL}/api/image?file=${encodeURIComponent(packages.thumbnail).substring(1)}`)
  return (
    <>
      {/* <div className="page-background">
        <div className="page-background-margin"

        >
          <Row>
            <Col lg={8} md={12}>
              <section>

                <div className="minimal-hero">
                  {Array.isArray(packages?.video) && packages.video.length > 0 ? (
                    <Carousel
                      fade
                      interval={3000}
                      pause={false}
                      controls={packages.video.length > 1}
                      indicators={packages.video.length > 1}
                      className="hero-carousel"
                    >
                      {packages.video.map((img, index) => {
                        const imagePath = typeof img === 'string' ? img.substring(1) : "";
                        return (
                          <Carousel.Item key={index}>
                            <img
                              className="hero-img-bg d-block w-100"
                              src={`${BASE_URL}/api/image?file=${encodeURIComponent(imagePath)}`}
                              alt={`${packages?.name} - ${index}`}
                              onError={(e) => { e.target.src = 'https://placehold.co/1200x800?text=Image+Not+Found'; }}
                            />
                          </Carousel.Item>
                        );
                      })}
                    </Carousel>
                  ) : typeof packages?.video === 'string' && packages.video.length > 0 ? (
                    <img
                      className="hero-img-bg"
                      src={`${BASE_URL}/api/image?file=${encodeURIComponent(packages.video.substring(1))}`}
                      alt={packages?.name}
                      onError={(e) => { e.target.src = 'https://placehold.co/1200x800?text=No+Image'; }}
                    />
                  ) : (
                    <div className="no-image-placeholder">
                      <div className="placeholder-text text-center text-white">
                        <FaSuitcase size={50} className="mb-3 opacity-50" />
                        <h3>{packages?.name}</h3>
                        <p>Explore this amazing package</p>
                      </div>
                    </div>
                  )}

                  <div className="hero-content-wrapper">
                    <Container>
                      <Row>
                        <Col lg={8}>
                          <div
                            className="mb-3 px-3 py-2 text-white"
                            style={{
                              background: "#0a3b78",
                              width: "fit-content",
                              fontSize: "12px",
                              padding: "0px 12px",
                              borderRadius: "4px",

                            }}
                          >
                            EXCLUSIVE {id?.startsWith("fit-") ? "PRIVATE" : "GROUP"} PACKAGE
                          </div>

                          <h1 className="main-package-title">{packages?.name}</h1>
                          <p className="sub-description text-white-50">
                            {packages?.itinerary?.length || 0} Days of Unforgettable Memories
                          </p>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </div>

              </section>

              <section id="pricing"><TourePricingDetails packages={packages} /></section>
              <section ><TourIncludes packages={packages} /></section>
              <section id="itinerary"><ItinerarySection packages={packages} /></section>
              <section id="hotels"><TourDetails packages={packages} /></section>
              <section id="includes"><TourInformation packages={packages} /></section>
              <section id="policy"><CancellationPolicy packages={packages} webSettings={webSettings} /></section>
            </Col>
            <Col lg={4} md={12}>
              <div style={{ position: "sticky", top: "80px", zIndex: 1000, padding: "10px 0" }}>
                <div className="quick-links-wrapper mx-auto mb-3" style={{ maxWidth: 'fit-content' }}>
                  <Container
                    className="shadow-sm border rounded-4 bg-white d-flex align-items-center px-4 py-1"
                    style={{ backdropFilter: "blur(10px)", backgroundColor: "rgba(255, 255, 255, 0.9)" }}
                  >
                    <Nav className="tour-tab-nav gap-2 align-items-center">
                      <Nav.Link href="#itinerary" className="text-dark d-flex align-items-center gap-2 px-3 custom-link">
                        <FaCompass className="text-primary" /> Itinerary
                      </Nav.Link>
                      <Nav.Link href="#price" className="text-dark d-flex align-items-center gap-2 px-3 custom-link">
                        <FaShieldAlt className="text-primary" /> Price
                      </Nav.Link>
                      <Nav.Link href="#hotels" className="text-dark d-flex align-items-center gap-2 px-3 custom-link">
                        <FaHotel className="text-primary" /> Hotels
                      </Nav.Link>
                      <Nav.Link href="#includes" className="text-dark d-flex align-items-center gap-2 px-3 custom-link">
                        <FaSuitcase className="text-primary" /> Inclusion
                      </Nav.Link>

                      <Nav.Link
                        className="text-dark d-flex align-items-center gap-2 px-3 custom-link"

                        onClick={async () => {
                          const pdfBlob = await generateFullTourPDF(packages, webSettings);
                          const pdfUrl = URL.createObjectURL(pdfBlob);
                          window.open(pdfUrl, "_blank");
                        }}
                      >
                        <FaSuitcase className="text-primary" /> View PDF
                      </Nav.Link>
                    </Nav>
                  </Container>
                </div>

                <section id="booking-card" className="mt-2">
                  <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                    <TourBookingCard packages={packages} />
                  </div>
                </section>
              </div>
            </Col>
          </Row>

        </div>
      </div> */}
      {/* <style dangerouslySetInnerHTML={{
        __html: `
         .modern-package-layout { background-color: #ffffff; color: #333; }
        .tour-tab-nav .nav-link { color: #555 !important; font-size: 13px; font-weight: 700; text-transform: uppercase; padding: 10px 20px; transition: 0.3s; }
        .tour-tab-nav .nav-link:hover { color: #007bff !important; }
         .anchor-nav {
           position: sticky;
           top: 0;
           background: #fff;
           z-index: 1000;
           border-bottom: 1px solid #eee;
         }

         .nav-item-link {
           color: #444 !important;
           font-weight: 600;
           font-size: 14px;
           transition: 0.3s;
           border-bottom: 2px solid transparent;
         }

         .nav-item-link:hover {
           color: #007bff !important;
           border-bottom: 2px solid #007bff;
         }

         .minimal-hero {
           height: 85vh;
           position: relative;
           background: #000;
         }

         .hero-img-bg {
           width: 100%;
           height: 100%;
           object-fit: cover;
           opacity: 0.7;
         }

         .hero-content-wrapper {
           position: absolute;
           bottom: 0;
           left: 0;
           width: 100%;
           padding: 60px 0;
           background: linear-gradient(to top, rgba(0,0,0,0.9), transparent);
         }

         .main-package-title {
           font-size: 2.5rem;
           font-weight: 800;
           color: #fff;
           line-height: 1.1;
         }

         .section-divider {
           margin: 60px 0;
           opacity: 0.08;
           border-top: 2px solid #000;
         }

         .booking-card-wrapper {
           padding-top: 20px;
           top: 80px;
         }

         .booking-inner-shadow {
           border-radius: 20px;
           overflow: hidden;
           box-shadow: 0 20px 40px rgba(0,0,0,0.1);
         }

         section h4 {
           font-weight: 700;
           margin-bottom: 25px;
           color: #1a1a1a;
           text-transform: uppercase;
           letter-spacing: 1px;
         }

         @media (max-width: 991px) {
           .main-package-title { font-size: 2.2rem; }
           .minimal-hero { height: 40vh; }
         }

.minimal-hero {
  height: 60vh;
  position: relative;
  overflow: hidden; 
  background: #000;
  border-radius: 20px;
  margin-top: 20px;
  
}

.hero-carousel, 
.hero-carousel .carousel-inner, 
.hero-carousel .carousel-item {
  height: 60vh;
}

.hero-content-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 60px 0;
  background: linear-gradient(to top, rgba(0,0,0,0.9), transparent);
  z-index: 20; 
  pointer-events: none; 
}

.hero-content-wrapper .container {
  pointer-events: auto;
}

.hero-img-bg {
  width: 100%;
  height: 100% !important;
  object-fit: cover;
  opacity: 0.6; 
}
       `}} /> */}
<div className="page-background">
  <div className="page-background-margin">

    <Row className="g-4">

      {/* ================= LEFT CONTENT ================= */}
      <Col lg={8} md={12}>

        {/* HERO SECTION */}
        <section>
          <div className="minimal-hero">

            {/* CAROUSEL / IMAGE */}
            {Array.isArray(packages?.video) && packages.video.length > 0 ? (
              <Carousel
                fade
                interval={3000}
                pause={false}
                controls={packages.video.length > 1}
                indicators={packages.video.length > 1}
                className="hero-carousel"
              >
                {packages.video.map((img, index) => {
                  const imagePath =
                    typeof img === "string" ? img.substring(1) : "";

                  return (
                    <Carousel.Item key={index}>
                      <img
                        className="hero-img-bg d-block w-100"
                        src={`${BASE_URL}/api/image?file=${encodeURIComponent(imagePath)}`}
                        alt={`${packages?.name} - ${index}`}
                        onError={(e) => {
                          e.target.src =
                            "https://placehold.co/1200x800?text=Image+Not+Found";
                        }}
                      />
                    </Carousel.Item>
                  );
                })}
              </Carousel>
            ) : typeof packages?.video === "string" &&
              packages.video.length > 0 ? (
              <img
                className="hero-img-bg"
                src={`${BASE_URL}/api/image?file=${encodeURIComponent(
                  packages.video.substring(1)
                )}`}
                alt={packages?.name}
                onError={(e) => {
                  e.target.src =
                    "https://placehold.co/1200x800?text=No+Image";
                }}
              />
            ) : (
              <div className="no-image-placeholder">
                <div className="placeholder-text text-center text-white">
                  <FaSuitcase size={50} className="mb-3 opacity-50" />
                  <h3>{packages?.name}</h3>
                  <p>Explore this amazing package</p>
                </div>
              </div>
            )}

            {/* HERO TEXT */}
            <div className="hero-content-wrapper">
              <Container>
                <Row>
                  <Col lg={8}>
                    <div
                      className="mb-3 px-3 py-2 text-white"
                      style={{
                        background: "#0a3b78",
                        width: "fit-content",
                        fontSize: "12px",
                        borderRadius: "4px",
                      }}
                    >
                      EXCLUSIVE{" "}
                      {id?.startsWith("fit-") ? "PRIVATE" : "GROUP"} PACKAGE
                    </div>

                    <h1 className="main-package-title">
                      {packages?.name}
                    </h1>

                    <p className="sub-description text-white-50">
                      {packages?.itinerary?.length || 0} Days of
                      Unforgettable Memories
                    </p>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </section>

        {/* SECTIONS */}
        <section id="pricing">
          <TourePricingDetails packages={packages} />
        </section>

        <section>
          <TourIncludes packages={packages} />
        </section>

        <section id="itinerary">
          <ItinerarySection packages={packages} />
        </section>

        <section id="hotels">
          <TourDetails packages={packages} />
        </section>

        <section id="includes">
          <TourInformation packages={packages} />
        </section>

        <section id="policy">
          <CancellationPolicy
            packages={packages}
            webSettings={webSettings}
          />
        </section>
      </Col>

      {/* ================= RIGHT SIDEBAR ================= */}
      <Col lg={4} md={12} className="d-none d-lg-block">

        <div
          style={{
            position: "sticky",
            top: "100px",
            zIndex: 10,
          }}
        >

          {/* QUICK NAV */}
          <div className="quick-links-wrapper mb-3">
            <Container
              className="shadow-sm border rounded-4 bg-white d-flex px-3 py-2"
              style={{
                overflowX: "auto",
                whiteSpace: "nowrap",
              }}
            >
              <Nav className="tour-tab-nav d-flex flex-nowrap gap-2">

                <Nav.Link href="#itinerary" className="custom-link">
                  <FaCompass className="text-primary me-1" />
                  Itinerary
                </Nav.Link>

                <Nav.Link href="#price" className="custom-link">
                  <FaShieldAlt className="text-primary me-1" />
                  Price
                </Nav.Link>

                <Nav.Link href="#hotels" className="custom-link">
                  <FaHotel className="text-primary me-1" />
                  Hotels
                </Nav.Link>

                <Nav.Link href="#includes" className="custom-link">
                  <FaSuitcase className="text-primary me-1" />
                  Inclusion
                </Nav.Link>

                <Nav.Link
                  onClick={async () => {
                    const pdfBlob = await generateFullTourPDF(
                      packages,
                      webSettings
                    );
                    const pdfUrl = URL.createObjectURL(pdfBlob);
                    window.open(pdfUrl, "_blank");
                  }}
                >
                  <FaFilePdf className="text-primary me-1" />
                  PDF
                </Nav.Link>

              </Nav>
            </Container>
          </div>

          {/* BOOKING CARD */}
          <section id="booking-card">
            <div className="card border-0 shadow-lg rounded-4">
              <TourBookingCard packages={packages} />
            </div>
          </section>

        </div>
      </Col>

    </Row>

  </div>

  {/* ================= RESPONSIVE CSS ================= */}
  <style>{`
    .minimal-hero {
      height: 70vh;
      position: relative;
      overflow: hidden;
      background: #000;
      border-radius: 20px;
      margin-top: 20px;
    }

    .hero-carousel,
    .hero-carousel .carousel-inner,
    .hero-carousel .carousel-item {
      height: 70vh;
    }

    .hero-img-bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.65;
    }

    .hero-content-wrapper {
      position: absolute;
      bottom: 0;
      width: 100%;
      padding: 40px 0;
      background: linear-gradient(to top, rgba(0,0,0,0.9), transparent);
      z-index: 10;
    }

    .main-package-title {
      font-size: 2.5rem;
      font-weight: 800;
      color: #fff;
    }

    .tour-tab-nav a {
      font-size: 13px;
      font-weight: 600;
      color: #444 !important;
      white-space: nowrap;
    }

    .tour-tab-nav a:hover {
      color: #007bff !important;
    }

    @media (max-width: 991px) {
      .minimal-hero,
      .hero-carousel,
      .hero-carousel .carousel-inner,
      .hero-carousel .carousel-item {
        height: 45vh;
      }

      .main-package-title {
        font-size: 1.6rem;
      }
    }
  `}</style>
</div>
    </>
  );
};

export default PackegDetails;

